import { render } from "./AnalysisReport.vue?vue&type=template&id=532f146a&scoped=true"
import script from "./AnalysisReport.vue?vue&type=script&lang=js"
export * from "./AnalysisReport.vue?vue&type=script&lang=js"

import "./AnalysisReport.vue?vue&type=style&index=0&id=532f146a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532f146a"]])

export default __exports__